import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  Avatar,
} from "@mui/material";
import FootBallImg from "../../../assets/customerAssets/football.png";
import Modal from "./Modal";

const getTime = (duration) => {
  let temp = duration;
  if (!temp) {
    return `0:00`;
  }
  if (duration > 60) {
    let min = 0;
    let sec = 0;
    min = Math.floor(temp / 60);
    sec = temp % 60;
    return `${min}:${sec}`;
  } else if (temp == 60) {
    return `1:00`;
  } else {
    return `0:${temp}`;
  }
};

const VideoComoponent = ({ img, duration, data, setTournamentData }) => {
  const [open, setOpen] = useState(false);
  const [videoDuration, setVideoDuration] = useState(duration);

  useEffect(() => {
    if (!data?.video) return;

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      setVideoDuration(Math.floor(video.duration));
    };

    video.src = data.video;
  }, [data.video]);
  return (
    <>
      <Box
        className="img_div"
        sx={img ? {} : { backgroundColor: "white", opacity: 0.6 }}
        onClick={() => setOpen(true)}
      >
        <img
          src={img ? img : FootBallImg}
          alt="video"
          className="img_fluid"
          style={img ? { objectFit: "cover" } : { objectFit: "contain" }}
        />

        <Box className="duration">{getTime(videoDuration)}</Box>
      </Box>
      <Modal
        open={open}
        setOpen={setOpen}
        data={data}
        setTournamentData={setTournamentData}
      />
    </>
  );
};

export default VideoComoponent;
